/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/components/influencer-projects.js":
/*!**************************************************!*\
  !*** ./src/js/components/influencer-projects.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InspiringProjects = /*#__PURE__*/function () {
  function InspiringProjects() {
    _classCallCheck(this, InspiringProjects);
    this.init();
  }
  return _createClass(InspiringProjects, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.container = document.querySelector('.projects__carousel');
      if (!this.container) return;
      this.track = this.container.querySelector('.projects__carousel-track');
      this.items = Array.from(this.container.querySelectorAll('.projects__item'));
      this.prevButton = this.container.querySelector('.projects__nav-button--prev');
      this.nextButton = this.container.querySelector('.projects__nav-button--next');
      this.indicators = this.container.querySelector('.projects__indicators');
      this.totalItems = this.items.length;
      this.currentIndex = 0;
      this.itemsPerView = this.getItemsPerView();

      // Listen for window resize to update itemsPerView
      window.addEventListener('resize', function () {
        var newItemsPerView = _this.getItemsPerView();
        if (newItemsPerView !== _this.itemsPerView) {
          _this.itemsPerView = newItemsPerView;
          _this.updateCarousel();
        }
      });
      this.setupIndicators();
      this.setupEventListeners();
      this.updateCarousel();
    }
  }, {
    key: "getItemsPerView",
    value: function getItemsPerView() {
      // Return number of items based on screen width
      if (window.innerWidth >= 1024) {
        return 3;
      } else if (window.innerWidth >= 768) {
        return 2;
      }
      return 1;
    }
  }, {
    key: "setupIndicators",
    value: function setupIndicators() {
      var _this2 = this;
      var totalGroups = Math.ceil(this.totalItems / this.itemsPerView);
      var _loop = function _loop(i) {
        var indicator = document.createElement('button');
        indicator.classList.add('projects__indicator');
        if (i === 0) indicator.classList.add('active');
        indicator.addEventListener('click', function () {
          _this2.goToGroup(i);
        });
        _this2.indicators.appendChild(indicator);
      };
      for (var i = 0; i < totalGroups; i++) {
        _loop(i);
      }
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this$prevButton,
        _this3 = this,
        _this$nextButton;
      (_this$prevButton = this.prevButton) === null || _this$prevButton === void 0 || _this$prevButton.addEventListener('click', function () {
        return _this3.prev();
      });
      (_this$nextButton = this.nextButton) === null || _this$nextButton === void 0 || _this$nextButton.addEventListener('click', function () {
        return _this3.next();
      });
    }
  }, {
    key: "updateCarousel",
    value: function updateCarousel() {
      var _this4 = this;
      // Update items visibility
      this.items.forEach(function (item, index) {
        var isInView = index >= _this4.currentIndex && index < _this4.currentIndex + _this4.itemsPerView;
        item.classList.toggle('active', isInView);
      });

      // Update indicators
      var currentGroup = Math.floor(this.currentIndex / this.itemsPerView);
      var indicators = this.indicators.querySelectorAll('.projects__indicator');
      indicators.forEach(function (indicator, index) {
        indicator.classList.toggle('active', index === currentGroup);
      });

      // Update navigation buttons
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex + this.itemsPerView >= this.totalItems;
      }
    }
  }, {
    key: "prev",
    value: function prev() {
      if (this.currentIndex > 0) {
        this.currentIndex = Math.max(0, this.currentIndex - this.itemsPerView);
        this.updateCarousel();
      }
    }
  }, {
    key: "next",
    value: function next() {
      if (this.currentIndex + this.itemsPerView < this.totalItems) {
        this.currentIndex = Math.min(this.totalItems - this.itemsPerView, this.currentIndex + this.itemsPerView);
        this.updateCarousel();
      }
    }
  }, {
    key: "goToGroup",
    value: function goToGroup(groupIndex) {
      this.currentIndex = groupIndex * this.itemsPerView;
      this.updateCarousel();
    }
  }]);
}(); // Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', function () {
  new InspiringProjects();
});

/***/ }),

/***/ "./src/scss/sections/influencer-makeover-carousel.scss":
/*!*************************************************************!*\
  !*** ./src/scss/sections/influencer-makeover-carousel.scss ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/sections/influencer-projects.scss":
/*!****************************************************!*\
  !*** ./src/scss/sections/influencer-projects.scss ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/influencer-projects": 0,
/******/ 			"assets/influencer-makeover-carousel": 0,
/******/ 			"assets/influencer-projects": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkresidence_supply"] = self["webpackChunkresidence_supply"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/influencer-makeover-carousel","assets/influencer-projects"], () => (__webpack_require__("./src/js/components/influencer-projects.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/influencer-makeover-carousel","assets/influencer-projects"], () => (__webpack_require__("./src/scss/sections/influencer-projects.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/influencer-makeover-carousel","assets/influencer-projects"], () => (__webpack_require__("./src/scss/sections/influencer-makeover-carousel.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;